import styled from '@emotion/styled';

import {
  COLOR_BRAND_SOFT,
  COLOR_BRAND_SOFT_TEXT,
  COLOR_SUCCESS_SOFT,
  COLOR_SUCCESS_TEXT,
  COLOR_SURFACE_INSET,
  COLOR_TEXT_CODE,
  COLOR_TEXT_MUTED,
  RADIUS_PILL,
} from './utils/variables';

export type PillTone = 'neutral' | 'accent' | 'success' | 'muted';

export type PillProps = {
  tone?: PillTone;
};

export const Pill = styled.span<PillProps>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: ${RADIUS_PILL};
  font-size: 12px;
  font-weight: 500;
  background: ${({ tone }) => {
    switch (tone) {
      case 'accent':
        return COLOR_BRAND_SOFT;
      case 'success':
        return COLOR_SUCCESS_SOFT;
      case 'muted':
        return COLOR_SURFACE_INSET;
      default:
        return COLOR_SURFACE_INSET;
    }
  }};
  color: ${({ tone }) => {
    switch (tone) {
      case 'accent':
        return COLOR_BRAND_SOFT_TEXT;
      case 'success':
        return COLOR_SUCCESS_TEXT;
      case 'muted':
        return COLOR_TEXT_MUTED;
      default:
        return COLOR_TEXT_CODE;
    }
  }};
`;
